import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Store } from "@ngrx/store";
import { RootStoreState } from "../../../store/state";
import { SubscribePageActions } from "../../../store/actions";
import { SubscriptionRequest } from "../../../@api/client-api";
import { selectServerError, selectIsLoading, selectServerErrorEmail } from "../../../store/selectors";
import { Observable } from "rxjs";

@Component({
  selector: "newsletter-subscribe-page",
  templateUrl: "./subscribe-page.component.html",
  styleUrl: "./subscribe-page.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscribePageComponent {
  isLoading$: Observable<boolean>;
  serverError$: Observable<string | null>;
  serverErrorEmail$: Observable<string | null>;

  hasAtLeastOneTopicSelected: boolean = true;
  subscriptionRequest: SubscriptionRequest = {
    subscriberDetails: {},
    topics: {
      leadershipTrends: false,
      boardGovernance: false,
      tmts: false,
      hr: false,
    },
  };

  constructor(
    // eslint-disable-next-line @ngrx/no-typed-global-store
    private readonly store: Store<RootStoreState>
  ) {
    this.isLoading$ = this.store.select(selectIsLoading);
    this.serverError$ = this.store.select(selectServerError);
    this.serverErrorEmail$ = this.store.select(selectServerErrorEmail);
  }

  onSubmit(form: NgForm) {
    if (!this.validateForm() || !form.valid) {
      form.form.markAllAsTouched();
      return;
    }

    // TODO: Manage state in store instead
    const subscriptionRequestCopy = JSON.parse(JSON.stringify(this.subscriptionRequest));

    this.store.dispatch(
      SubscribePageActions.subscribeInitiated({
        subscriptionRequest: subscriptionRequestCopy,
      })
    );
  }

  validateForm(): boolean {
    const details = this.subscriptionRequest.subscriberDetails;
    const topics = this.subscriptionRequest.topics;
    this.hasAtLeastOneTopicSelected = topics
      ? Object.values(topics).some((value) => value === true)
      : false;

    return (
      details != null &&
      details.firstName != null &&
      details.lastName != null &&
      details.email != null &&
      details.country != null &&
      details.country != undefined &&
      this.hasAtLeastOneTopicSelected
    );
  }
}
